import { connect } from 'react-redux'
import { reduxForm, change, formValueSelector } from 'redux-form/immutable'
import moment from 'moment'
import { withTranslation } from 'react-i18next'

import { TIME_PREFERENCES_FORM } from 'app/constants/profile'
import { getTimeFromDecimal } from 'helpers/dateHelper'
import { MORNING_HOURS, EVENING_HOURS } from 'app/constants/notificationHours'
import {
  isDesktopNotificationsAvailable,
  getIdentityTimezone,
  isSMSAvailable,
  isIdentityHasSmsNotificationType,
  getIdentityFirstLoginFlow,
  getIdentityPendingGetProgress,
} from 'store/entities/identity/selectors'
import TimePreferencesForm from './TimePreferencesForm'
import { modal } from 'store/entities/modal/actions'
import withDidMountRequest from 'app/connectors/withDidMountRequest'
import { getIdentityProgress } from 'store/entities/identity/actions'
const selector = formValueSelector(TIME_PREFERENCES_FORM)

const mapStateToProps = (state) => ({
  // TODO: should be obtained from the selector
  morningHours: MORNING_HOURS,
  eveningHours: EVENING_HOURS.slice(
    EVENING_HOURS.findIndex((element) => element === selector(state, 'commitNotificationTime')) + 1
  ),
  isDesktopNotificationsAvailable: isDesktopNotificationsAvailable(state),
  timezone: getIdentityTimezone(state),
  isSMSAvailable: isSMSAvailable(state),
  notificationTypeValue: selector(state, 'notificationType'),
  phoneISO: selector(state, 'phoneISO'),
  isIdentityHasSmsNotificationType: isIdentityHasSmsNotificationType(state),
  isLoginFlowFinished: getIdentityFirstLoginFlow(state),
  isLoading: getIdentityPendingGetProgress(state),
})

const mapDispatchToProps = {
  changeField: (field, value) => change(TIME_PREFERENCES_FORM, field, value),
  showModal: modal.show,
  onRequest: () => getIdentityProgress(),
}

const mergeProps = (stateProps, { changeField, ...restDispatchProps }, ownProps) => ({
  ...stateProps,
  ...restDispatchProps,
  ...ownProps,
  /**
   * Normalize commitNotificationTime and committedNotificationTime - first should be less then second to 0.5 hour
   * @param field - changed field of the form
   */
  fieldWasChanged: (field) => (value, prevValue, values) => {
    const commit = values.get('commitNotificationTime')
    const committed = values.get('committedNotificationTime')
    if (moment.duration(commit).asHours() + 0.5 > moment.duration(committed).asHours()) {
      if (field === 'commitNotificationTime') {
        const newCommitted = getTimeFromDecimal(moment.duration(commit).asHours() + 0.5)
        changeField('committedNotificationTime', newCommitted)
      } else {
        const newCommit = getTimeFromDecimal(moment.duration(committed).asHours() - 0.5)
        changeField('commitNotificationTime', newCommit)
      }
    }
    return value
  },
})

export default connect(
  mapStateToProps,
  mapDispatchToProps,
  mergeProps
)(
  reduxForm({
    form: TIME_PREFERENCES_FORM,
    enableReinitialize: true,
    destroyOnUnmount: false,
  })(withTranslation('user')(withDidMountRequest(TimePreferencesForm)))
)
